<template>
  <div>
    <label for="logo-upload" class="form-label">Company Logo</label>

    <!-- Show current logo -->
    <div v-if="currentLogo && !previewLogo" class="mb-3">
      <img
        :src="currentLogo"
        alt="Current Logo"
        class="img-thumbnail"
        style="max-height: 150px;"
      />
    </div>

    <!-- Show preview if available -->
    <div v-if="previewLogo" class="mb-3">
      <img
        :src="previewLogo"
        alt="Preview Logo"
        class="img-thumbnail"
        style="max-height: 150px;"
      />
    </div>

    <!-- File input -->
    <b-form-file
      id="logo-upload"
      v-model="newLogo"
      accept="image/*"
      placeholder="Choose a new logo..."
      @input="onFileChange"
    ></b-form-file>

    <!-- Upload Button -->
    <b-button
      class="mt-3"
      variant="primary"
      :disabled="!newLogo || isUploading"
      @click="uploadLogo"
    >
      <b-spinner small v-if="isUploading"></b-spinner>
      <span v-else>Upload Logo</span>
    </b-button>
  </div>
</template>

<script>
import { BFormFile, BButton, BSpinner } from "bootstrap-vue";

export default {
  components: { BFormFile, BButton, BSpinner },
  props: {
    currentLogo: {
      type: String,
      default: ""
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newLogo: null,
      previewLogo: null,
      isUploading: false
    };
  },
  methods: {
    onFileChange(file) {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        this.previewLogo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async uploadLogo() {
      if (!this.newLogo) return;

      this.isUploading = true;
      const formData = new FormData();
      formData.append("image", this.newLogo);

      try {
        await this.$http.post(this.uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        this.$emit("success");
        this.previewLogo = null;
        this.newLogo = null;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Upload failed", error);
        this.$emit("error", error);
      } finally {
        this.isUploading = false;
      }
    }
  }
};
</script>
